import React, { useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { MenuSelectors, UserContextSelectors } from "../../redux/selectors";
import { MenuActionCreators } from "../../redux/action-creators";
import { SportCategoryMenuItem } from "../Menu/SportCategoryMenuItem";
import { useClickOutside } from "../../hooks";
import classNames from "classnames";
import InnerMenuHeader from "../Menu/Categories/InnerMenuHeader";
import MenuItemList from "../Menu/Categories/MenuItemList";

const SportAZMenu = props => {
  const { item, automationId } = props;

  const [title, setTitle] = useState("");

  useEffect(() => {
    const kambiTitle = item?.title?.defaultMessage;
    const innerMenuHeaderProps = kambiTitle ? kambiTitle : item.title;
    setTitle(innerMenuHeaderProps);
  }, [item.title]);

  const ignoreClass = `do-not-close-${automationId}`;

  const quickLinksInnerMenuVisible = useSelector(
    MenuSelectors.quickLinksInnerMenuVisible
  );
  const quickLinksInnerMenuItem = useSelector(
    MenuSelectors.quickLinksInnerMenuItem
  );
  const favouriteSportsRunningInsideInnerMenu = useSelector(
    MenuSelectors.favouriteSportsRunningInsideInnerMenu
  );
  const isMobile = useSelector(UserContextSelectors.isMobile);

  const dispatch = useDispatch();

  const onItemClick = () => {
    dispatch(MenuActionCreators.hideQuickLinksInnerMenu());
    dispatch(
      MenuActionCreators.setFavouriteSportsRunningInsideInnerMenu(false)
    );
  };

  const currentRef = useClickOutside(
    () => {
      dispatch(MenuActionCreators.hideQuickLinksInnerMenu());
      dispatch(
        MenuActionCreators.setFavouriteSportsRunningInsideInnerMenu(false)
      );
    },
    {
      ignoreClass: ["generic-drawer", ignoreClass],
      disabled: !(
        (quickLinksInnerMenuVisible && item === quickLinksInnerMenuItem) ||
        favouriteSportsRunningInsideInnerMenu
      )
    }
  );

  const menuClasses = useMemo(
    () =>
      classNames("category-menu", {
        "inner-mobile-menu": isMobile,
        "sub-menu": !isMobile,
        "drawer-show-left":
          (quickLinksInnerMenuVisible ||
            favouriteSportsRunningInsideInnerMenu) &&
          quickLinksInnerMenuItem === item,
        [ignoreClass]: !!ignoreClass
      }),
    [
      isMobile,
      quickLinksInnerMenuVisible,
      favouriteSportsRunningInsideInnerMenu,
      quickLinksInnerMenuItem,
      item,
      ignoreClass
    ]
  );

  return (
    <div className={menuClasses} ref={currentRef}>
      {!isMobile && <InnerMenuHeader title={title} />}
      <MenuItemList
        items={item.items}
        component={SportCategoryMenuItem}
        termKeyPrefix={item.termKeyPrefix}
        onClick={onItemClick}
      />
    </div>
  );
};

SportAZMenu.propTypes = {
  item: PropTypes.object,
  automationId: PropTypes.string
};

export default React.memo(SportAZMenu);
